import CharacterPicker from './CharacterPicker';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import when from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import mapProps from 'recompose/mapProps';
import withQueryParams from '../../hocs/withQueryParams';
import withProductCustomisation from '../../hocs/withProductCustomisation';
import withGlobalContent from '../../hocs/withGlobalContent';
import withMedia from '../../hocs/withMediaQueries';
import { withFormik } from 'formik';
import { getTransform } from './helpers';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';

const enhance = compose(
  withState('activeNav', 'setActiveNav', null),
  when(props => props.items.length === 0, renderNothing, c => c),
  withProductCustomisation,
  withFormik({
    mapPropsToValues: props => ({
      character_selection:
      props.productCustomisation.character_selection ||
      props.items.map(item => ({
        letter: item.letter,
        [item.type]: item.defaultCharacter,
      })),
    }),
  }),
  withQueryParams,
  withHandlers({
    handleChangeCharacter: props => (characterIndex, letter, character) => {
      const characterSelection = props.values.character_selection.map(
        (selection, index) =>
          index === characterIndex ? { ...selection, character } : selection,
      );
      props.setFieldValue('character_selection', characterSelection);
      props.updateQueryParams({ character_selection: characterSelection });
      props.updateProductCustomisation({ character_selection: characterSelection });
      props.setActiveNav(null);
    },
  }),
  withMedia,
  withGlobalContent,
  mapProps(({ globalContent, ...props }) => {
    const canvasContent = get(globalContent, 'canvas.body', []);
    const characterPickerContent =
      canvasContent.find(item => item.sliceType === 'character_picker') || {};
    return {
      ...props,
      prismicContent: characterPickerContent.primary || {
        selectDescription: 'Choose another character for %{letter}',
        cancelCta: 'Cancel',
        changeCta: 'Change',
        selectCta: 'Select',
        selectInUse: 'In use',
      },
    };
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (
        prevProps.productCustomisation.name !== this.props.productCustomisation.name ||
        prevProps.productCustomisation.locale !== this.props.productCustomisation.locale ||
        !isEqual(prevProps.items, this.props.items)
      ) {
        this.props.removeQueryParams('character_selection');
        this.props.updateProductCustomisation({ character_selection: null });
        this.props.resetForm();
      }

      if (this.props.needsTransform && this.props.activePage !== prevProps.activePage) {
        const index = this.props.items.findIndex(item => item.index === this.props.activePage);
        if (index >= 0) {
          const transform = getTransform(index, window.innerWidth);
          this.props.setTransform(transform);
        }
      }
    },
  }),
);

export default enhance(CharacterPicker);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CharacterPicker/index.js